/**
 * PDF Generator Factory
 * Routes to appropriate PDF generator based on strategy type
 */

import { AstroflipPDFGenerator } from './AstroflipPDFGenerator'
import { BuyHoldPDFGenerator } from './BuyHoldPDFGenerator'
import { CMAPDFGenerator } from './CMAPDFGenerator'
import { FixFlipPDFGenerator } from './FixFlipPDFGenerator'
import { MarketingPDFGenerator } from './MarketingPDFGenerator'
import { ShortTermRentalPDFGenerator } from './ShortTermRentalPDFGenerator'
import { WholesalePDFGenerator } from './WholesalePDFGenerator'

export class PDFGeneratorFactory {
  /**
   * Create the appropriate PDF generator based on strategy type
   */
  static createGenerator(
    strategyType,
    property,
    state,
    closeSnackbar,
    urlAffiliate,
    affiliate,
    urlDomain,
    session,
    comps,
  ) {
    switch (strategyType) {
      //Several strategies would have unique pages if it was Southern Impressions, but we don't think they work with us anymore
      case 'buyHold':
        return new BuyHoldPDFGenerator(
          property,
          state,
          closeSnackbar,
          urlAffiliate,
          affiliate,
          urlDomain,
          session,
          comps,
        )

      case 'fixFlip':
        return new FixFlipPDFGenerator(
          property,
          state,
          closeSnackbar,
          urlAffiliate,
          affiliate,
          urlDomain,
          session,
          comps,
        )

      case 'marketing':
        return new MarketingPDFGenerator(
          property,
          state,
          closeSnackbar,
          urlAffiliate,
          affiliate,
          urlDomain,
          session,
          comps,
        )

      case 'shortTermRental':
        return new ShortTermRentalPDFGenerator(
          property,
          state,
          closeSnackbar,
          urlAffiliate,
          affiliate,
          urlDomain,
          session,
          comps,
        )

      case 'wholesale':
        return new WholesalePDFGenerator(
          property,
          state,
          closeSnackbar,
          urlAffiliate,
          affiliate,
          urlDomain,
          session,
          comps,
        )

      case 'astroflip':
        return new AstroflipPDFGenerator(
          property,
          state,
          closeSnackbar,
          urlAffiliate,
          affiliate,
          urlDomain,
          session,
          comps,
        )

      case 'CMA':
        return new CMAPDFGenerator(
          property,
          state,
          closeSnackbar,
          urlAffiliate,
          affiliate,
          urlDomain,
          session,
          comps,
        )

      // case 'uploaded':
      //   // TODO: Implement UploadedPDFGenerator
      //   return new BuyHoldPDFGenerator(
      //     property,
      //     state,
      //     closeSnackbar,
      //     urlAffiliate,
      //     affiliate,
      //     urlDomain,
      //   ) // Fallback for now

      default:
        return new BuyHoldPDFGenerator(
          property,
          state,
          closeSnackbar,
          urlAffiliate,
          affiliate,
          urlDomain,
        )
    }
  }

  /**
   * Generate PDF for the specified strategy
   */
  static async generatePDF(
    strategyType,
    property,
    state,
    closeSnackbar,
    urlAffiliate,
    affiliate,
    urlDomain,
    session,
    comps,
  ) {
    const generator = this.createGenerator(
      strategyType,
      property,
      state,
      closeSnackbar,
      urlAffiliate,
      affiliate,
      urlDomain,
      session,
      comps,
    )
    return await generator.generatePDF()
  }
}
